import CategoryContainer from '../../../containers/CategoryContainer'

const Categories = () => <CategoryContainer />

export default Categories